const actionTypes = {
  SET_MODAL_BULK_FILE_UPLOAD_ACTIVED: 'setModalBulkFileUploadActived',
  SET_MODAL_DISCONTINUE_UPLOAD_ACTIVED: 'setModalContinueUploadActived',
  SET_UPLOAD_PROGRESS_STATUS: 'setModalProgressStatus',
  SET_TOTAL_COUNT: 'setTotalCount',
  SET_CURRENT_COUNT: 'setCurrentCount',
  SET_UPLOAD_RESULT_COUNT: 'setUploadResultCount',
  SET_FILE_CHECK_ERROR: 'setFileCheckError',
  SET_UPLOAD_FILES: 'setUploadFiles',
}

export default actionTypes
